export const FETCH_ALL_POSTS = "FETCH_ALL_POSTS";
export const CREATE_POST = "CREATE_POST";
export const UPDATE_POST = "UPDATE_POST";
export const DELETE_POST = "DELETE_POST";
export const LIKE_POST = "LIKE_POST";
export const FETCH_SEARCH_POSTS = 'FETCH_SEARCH_POSTS';

export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
